var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { elementInstance } from "../instance.mjs";
import { customerElementId, paymentIntentClientSecret } from "./elements.mjs";
import { countryCodes, getBillingAddress, getLocaleByCountryCode, getShippingAddress, loadStripeIfNeeded } from "./utils.mjs";
let addressElements = null;
export const getAddressElements = () => {
    return addressElements;
};
export const initializeStripeAddressElements = (state, actions, cartPayment) => {
    elementInstance({
        elementId: customerElementId,
        idempotencyKey: state.id,
        onMount: (e) => __awaiter(void 0, void 0, void 0, function* () {
            const stripe = yield loadStripeIfNeeded(cartPayment);
            const elements = stripe.elements({
                clientSecret: paymentIntentClientSecret(state),
                locale: getLocaleByCountryCode(state.countryCode),
            });
            const shippingElement = createShippingAddressElement(elements, state);
            const billingElement = createBillingAddressElement(elements, state);
            addressElements = { elements, shippingElement, billingElement };
            shippingElement.on('blur', () => __awaiter(void 0, void 0, void 0, function* () {
                const billingDetails = yield billingElement.getValue();
                const shippingDetails = yield shippingElement.getValue();
                const address = getShippingAddress(shippingDetails);
                const useBillingAddress = shouldUseBillingAddress(billingDetails, shippingDetails);
                yield Promise.all([
                    actions.setAddress(address),
                    actions.setUseBillingAddress(useBillingAddress),
                    // TODO: Remove this when we know where to set the phone number and email
                    actions.setPhoneNumber('0712345678'),
                    actions.setEmail('test@stickerapp.com'),
                ]);
            }));
            billingElement.on('blur', () => __awaiter(void 0, void 0, void 0, function* () {
                const billingDetails = yield billingElement.getValue();
                const shippingDetails = yield shippingElement.getValue();
                const address = getBillingAddress(billingDetails);
                const useBillingAddress = shouldUseBillingAddress(billingDetails, shippingDetails);
                const setAddressAction = useBillingAddress ? actions.setBillingAddress(address) : Promise.resolve();
                yield Promise.all([setAddressAction, actions.setUseBillingAddress(useBillingAddress)]);
            }));
            const shippingContainer = document.createElement('div');
            shippingElement.mount(shippingContainer);
            e.appendChild(shippingContainer);
            const billingContainer = document.createElement('div');
            billingContainer.style.marginTop = '15px';
            billingElement.mount(billingContainer);
            e.appendChild(billingContainer);
            return () => {
                shippingElement.unmount();
                billingElement.unmount();
            };
        }),
    });
};
// If the checkbox is selected, the billing details will automatically match the shipping details.
// Since Stripe does not offer a way to detect checkbox changes, we handle this manually.
const shouldUseBillingAddress = (billingDetails, shippingDetails) => {
    return billingDetails.complete && JSON.stringify(billingDetails.value) !== JSON.stringify(shippingDetails.value);
};
const createShippingAddressElement = (elements, state) => {
    return elements.create('address', Object.assign({ mode: 'shipping', defaultValues: state.customer.address && {
            firstName: state.customer.address.firstName,
            lastName: state.customer.address.lastName,
            address: {
                country: state.countryCode.toUpperCase(),
                line1: state.customer.address.address1,
                line2: state.customer.address.address2,
                city: state.customer.address.city,
                state: state.customer.address.stateOrProvince,
                postal_code: state.customer.address.postalCode,
            },
        } }, defaultAddressElementOptions));
};
const createBillingAddressElement = (elements, state) => {
    var _a, _b;
    return elements.create('address', Object.assign({ mode: 'billing', defaultValues: state.customer.billingAddress && {
            firstName: state.customer.billingAddress.firstName,
            lastName: state.customer.billingAddress.lastName,
            address: {
                country: (_b = (_a = state.customer.billingAddress.countryCode) === null || _a === void 0 ? void 0 : _a.toUpperCase()) !== null && _b !== void 0 ? _b : '',
                line1: state.customer.billingAddress.address1,
                line2: state.customer.billingAddress.address2,
                city: state.customer.billingAddress.city,
                state: state.customer.billingAddress.stateOrProvince,
                postal_code: state.customer.billingAddress.postalCode,
            },
        } }, defaultAddressElementOptions));
};
const countryCodesExcluded = ['BR', 'RU'];
const defaultAddressElementOptions = {
    allowedCountries: countryCodes.filter((code) => !countryCodesExcluded.includes(code)),
    display: {
        name: 'split',
    },
};
//# sourceMappingURL=addressElements.js.map